<template>
    <main class="p-4 flex-fill d-flex flex-column page-fade">
        <slot />
    </main>
</template>
<script>
import WOW from 'wowjs';

const wow = new WOW.WOW({
    offset: 0,
    live: true
});

export default {
    created() {
        wow.init();
    }
};
</script>
